import { render, staticRenderFns } from "./AdminMsgAccueil.vue?vue&type=template&id=1a3e64b0"
import script from "./AdminMsgAccueil.vue?vue&type=script&lang=ts"
export * from "./AdminMsgAccueil.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports